import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

// Layout
import Layout from './components/layout/Layout';

// Auth
import Login from './pages/auth/Login';
import Register from './pages/auth/Register';
import ProtectedRoute from './components/auth/ProtectedRoute';

// Pages
import Dashboard from './pages/dashboard/Dashboard';
import QuestionList from './pages/questions/QuestionList';
import QuestionCreate from './pages/questions/QuestionCreate';
import QuestionEdit from './pages/questions/QuestionEdit';
import UserList from './pages/users/UserList';
import UserCreate from './pages/users/UserCreate';
import UserEdit from './pages/users/UserEdit';
import Leaderboard from './pages/leaderboard/Leaderboard';
import Winners from './pages/leaderboard/Winners';
import Profile from './pages/profile/Profile';
import NotFound from './pages/NotFound';

function App() {
  return (
    <>
      <Routes>
        {/* Auth Routes */}
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        
        {/* Protected Routes */}
        <Route element={<ProtectedRoute><Layout /></ProtectedRoute>}>
          <Route path="/" element={<Navigate to="/dashboard" replace />} />
          <Route path="/dashboard" element={<Dashboard />} />
          
          {/* Question Routes */}
          <Route path="/questions" element={<QuestionList />} />
          <Route path="/questions/create" element={<QuestionCreate />} />
          <Route path="/questions/:id" element={<QuestionEdit />} />
          
          {/* User Routes */}
          <Route path="/users" element={<UserList />} />
          <Route path="/users/create" element={<UserCreate />} />
          <Route path="/users/:id" element={<UserEdit />} />
          
          {/* Leaderboard Routes */}
          <Route path="/leaderboard" element={<Leaderboard />} />
          <Route path="/winners" element={<Winners />} />
          
          {/* Profile Route */}
          <Route path="/profile" element={<Profile />} />
        </Route>
        
        {/* 404 Page */}
        <Route path="*" element={<NotFound />} />
      </Routes>
      
      <ToastContainer position="top-right" autoClose={3000} hideProgressBar={false} />
    </>
  );
}

export default App;